import { useLocation, useNavigate } from "react-router-dom";
import { useMemo } from "react";
import {
  WebengageGeneralButtonEvent,
  handleClickMetrixEvents,
} from "containers/services/events.data";
import { useAppContext } from "utils/context";
import { useSelector } from "react-redux";
import Logo from "./components/logo";
import Header from "./components/header";
import Content from "./components/content/content";
import CallbackButton from "./components/button";

const Receipt = () => {
  const { metrixInstance } = useAppContext();
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location?.search);
  const prevMenu = useSelector((state) => state?.routerReducer?.prevMenu);

  useMemo(async () => {
    await handleClickMetrixEvents(metrixInstance, "payment-receipt", [
      {
        key: "is_successful",
        value: String(params.get("status") === "SUCCESS"),
      },
    ]);
  }, [params]);

  const onCallBackClick = () => {
    if (localStorage.getItem("bank_limit_receipt") === "true") {
      navigate(`/bank/onboarding`, { replace: true });
      localStorage.removeItem("bank_limit_receipt");
    } else {
      navigate(`/fund-orders`, { replace: true });
    }
    WebengageGeneralButtonEvent(
      "buy-fund-button-after-payment",
      prevMenu,
      "button",
      { Status: params.get("status") === "SUCCESS" ? "success" : "failed" }
    );
  };

  return (
    <div className="bg-gray--9 sm:bg-inherit h-screen py-40 px-5">
      <div className="bg-white rounded-xl pt-8 pb-6  max-w-sm   mx-auto ">
        <Logo data={params} />
        <Header data={params} />
        <Content data={params} />
        <CallbackButton onCallBackClick={onCallBackClick} />
      </div>
    </div>
  );
};
export default Receipt;
